import React from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useDeleteTariff } from '../../api/use-delete-tariff'

export interface DeleteTariffDialogProps {
  tariffId: string
  installationId: number
  open: boolean
  onClose: () => void
  place: number
}

/**
 * Dialog component for delete tariff which is open on click delete tariff option in 3 dot menu
 * @param tariffId - unique identifier for single tariff
 * @param installationId - unique identifier for installation
 */
export const DeleteTariffDialog: React.FC<DeleteTariffDialogProps> = ({ tariffId, installationId, open, onClose, place }) => {
  const { t } = useCustomTranslation()

  const { isLoading, deleteTariff } = useDeleteTariff(onClose)

  const handleDeleteTariff = (): void => {
    deleteTariff({ installationId, tariffId })
  }

  return (
    <Dialog
      maxWidth={'sm'}
      title={t('emobility.tariffs.deleteTitle')}
      onClose={onClose}
      place={place}
      actions={{
        primary: {
          disabled: isLoading,
          isLoading: isLoading,
          name: t('emobility.tariffs.delete'),
          onClick: handleDeleteTariff,
        },
        secondary: {
          name: t('emobility.tariffs.cancel'),
        },
      }}
    />
  )
}
